<template>
    <div class="add">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>城市管理</el-breadcrumb-item>
                <el-breadcrumb-item>新增城市</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>新增城市</h2>
                <div class="item" @click="city">城市列表</div>
            </div>
        </div>
        <div class="page-content">
            <div class="add-box">
                <el-form ref="form" :model="form" label-width="100px" align="left" style="width: 350px;">
                    <el-form-item label="选择省份">
                        <el-select v-model="form.region" placeholder="请选择活动区域">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择城市">
                        <el-select v-model="form.region" placeholder="请选择活动区域">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系人">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人电话">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即创建</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "add",
        data(){
            return{
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                }
            }
        },
        methods:{
            city(){
                this.$router.push({path: '/city/city'});
            },
            onSubmit() {
                console.log('submit!');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .top-box{
        width: 100%;
        height: 100px;
        background-color: #ffffff;
        padding: 20px;
    .tab-list{
        margin-top: 20px;
    h2{
        margin-right: 20px;
        padding-right: 20px;
        border-right: 1px solid #eaeaea;
    }
    .item{
        font-size: 16px;
        color: #409EFF;
        display: flex;
        align-items: center;
        cursor: pointer;
    .icon{
        font-size: 20px;
        color: #409EFF;
        margin-right: 5px;
    }
    }
    }

    }
    .page-content{
        padding: 20px;
        .add-box{
            background-color: #fff;
            padding: 30px;
        }
    }

</style>
